if($('.site-msg.information').length){
    $('.site-msg.information').prepend('<span class="arrow"></span>')
    $('.site-msg.information .container').prepend('<div class="image"><img src="'+infoIkona+'" alt="Mýdlenka ikona"></div>')
}

$(document).on('click', '.site-msg.information .arrow', function(){
    $(this).closest('.site-msg.information').toggleClass('closeIt')
    $(this).closest('.site-msg.information').find('.text').slideToggle(0)
    if ($(this).closest('.site-msg.information').css('width') === '90px') {
        $(this).closest('.site-msg.information').animate({
            width: '90%'
        }, 10);
        sessionStorage.setItem('infoMsgState', 'openInfoMessage');
    } else {
        $(this).closest('.site-msg.information').animate({
            width: '90px'
        }, 500);
        sessionStorage.setItem('infoMsgState', 'hideInfoMessage');
    }
})

$(document).ready(function(){
    if (sessionStorage.getItem('infoMsgState') === 'hideInfoMessage') {
        $('.site-msg.information').toggleClass('closeIt')
        $('.site-msg.information').find('.text').slideToggle(0)
        $('.site-msg.information').animate({
            width: '90px'
        }, 0);
    }
})